import { useEffect, useRef } from 'react';
import useEventListener from '../Utils/useEventListener';

const useChartReflow = () => {
  const chartWrapperReference = useRef();
  const CHART_RESIZE_EVENT_NAME = "chart-resize"

  let reflowFunction;
  const chartCallbackFunction = (chart) => {
    reflowFunction = () => {
      // On re-renders, highcharts-react returns a prototype object in interim state. To check if actual chart is present, below condition is evaluated
      if (chart?.options?.chart) {
        chart.reflow();
      }
    };
  };
  useEffect(() => {
    let resizeObserver = new ResizeObserver(entries => {
      for (let _entry of entries) {
        const event = new CustomEvent(CHART_RESIZE_EVENT_NAME);
        document.dispatchEvent(event);
      }
    });
    resizeObserver.observe(chartWrapperReference.current);
    document.addEventListener(CHART_RESIZE_EVENT_NAME, reflowFunction, false);
    return () => {
      document.removeEventListener(CHART_RESIZE_EVENT_NAME, reflowFunction, false);
    };
  }, []);

  return {
    chartWrapperReference,
    chartCallbackFunction
  }
};

export default useChartReflow;
